import React, { useEffect } from "react"
import classnames from "@utils/classnames"
import styles from "./rolesSelector.scss"

import arrowImgPath from "@images/arrow-down.png"

const cdnPrefix = "https://site.gcores.com/assets/fusion2021/roles/"

const RolesSelector = React.memo(({ onClick }) => {
  useEffect(() => {
    function initGlitchBox(selector) {
      const container = document.querySelector(selector)
      // container.style.border = '20px solid black'
      const toUrl = filename => cdnPrefix + filename
      const avatars = {
        A: ["A1.png", "A2.png", "A3.png"].map(toUrl),
        B: ["B1.png", "B2.png", "B3.png"].map(toUrl),
        C: ["C1.png", "C2.png", "C3.png"].map(toUrl),
        D: ["D1.png", "D2.png", "D3.png"].map(toUrl),
      }

      const preloadImages = function(sources, type) {
        return Promise.all(
          sources.map(
            src =>
              new Promise((resolve, reject) => {
                const image = new Image()
                image.onload = () => resolve([image, type])
                // modify onerror to throw or swallow failure
                image.onerror = () => reject.apply(null, arguments)
                image.src = src
              })
          )
        )
      }

      Promise.all(
        Object.entries(avatars).map(([type, imgNames]) =>
          preloadImages(imgNames, type)
        )
      )
        .then(allImages => {
          allImages.forEach((images, i) => {
            const group = document.createElement("div")
            const type = images[0][1]
            group.className = `block block-${type}`

            const chosen = document.createElement("div")
            const chosenWrapper = document.createElement("div")
            chosenWrapper.className = "imgWrapper imgWrapperBg"
            chosen.className = "imgWrapperBg"
            // chosenImage.className = "avatar"
            chosenWrapper.appendChild(chosen)
            const arrowImg = document.createElement("img")
            arrowImg.src = arrowImgPath
            arrowImg.className = "chosenArrow"
            chosen.appendChild(arrowImg)

            group.appendChild(chosenWrapper)

            images.forEach(([img], i) => {
              const wrapper = document.createElement("div")
              img.className = "avatar"
              if (i > 0) {
                hide(img)
              }
              wrapper.className = "imgWrapper"
              wrapper.appendChild(img)
              group.appendChild(wrapper)
            })
            const nameImg = document.createElement("img")
            nameImg.src = toUrl(`${type}-name.png`)
            nameImg.className = `roleName roleName-${type}`

            group.appendChild(nameImg)
            group.addEventListener("click", () => {
              onClick(i)
            })
            container.appendChild(group)
          })
          return allImages.map(item => item.map(([img]) => img))
        })
        .then(allImages => {
          const INTERVAL = 300
          let group = null
          setTimeout(function loop() {
            const availableGroups = allImages.filter(_ => _ !== group)
            group = availableGroups[random(availableGroups.length)]
            const visibleOne = group.filter(isVisible)[0]
            const nextOne = group.filter(img => img !== visibleOne)[
              random(group.length - 1)
            ]
            visibleOne.addEventListener("animationend", function anend() {
              visibleOne.removeEventListener("animationend", anend)
              visibleOne.parentNode.parentNode.classList.remove("active")
              setTimeout(loop, INTERVAL)
            })
            visibleOne.parentNode.parentNode.classList.add("active")
            show(nextOne)
            hide(visibleOne)
          }, 0)
        })

      // helpers
      function random(n) {
        return Math.floor(Math.random() * n)
      }
      function hide(node) {
        node.classList.add("invisible")
      }
      function show(node) {
        node.classList.remove("invisible")
      }
      function isVisible(node) {
        return !node.classList.contains("invisible")
      }
      function isInvisible(node) {
        return !isVisible(node)
      }
    }

    initGlitchBox(".glitch-container")
  }, [])
  return <div className="glitch-container"></div>
})

RolesSelector.displayName = "RolesSelector"
export default RolesSelector
